import SweetScroll from '@/helpers/sweet_scroll';

pageLoad('pages_root', async () => {
  $('.red_headline .learn-more').on('click', async () => {
    (await SweetScroll.asyncInstance()).toElement(
      document.querySelector('.benefits'), { duration: 750, offset: -40 }
    );
  });
});
